import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Routes, Route } from 'react-router-dom';
import { GrPrevious, GrNext } from 'react-icons/gr';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styless
import 'swiper/css';

/* 컴포넌트 */
import Header from '../components/Header';
import Footer from '../components/Footer';

/* 아이콘 */
import { AiOutlinePicture } from "react-icons/ai";

const Ai = () => {
    return (
        <>
            {/* 헤더 */}
            <Header />
            {/* 컨텐츠 */}
            <Routes>
                <Route path='/' element={
                    <>
                        <div className='Hslide'>
                            <GrPrevious className='prev' /><p>효과 적용하기</p><GrNext className='next' />
                        </div>
                        <div className='ai'>얼굴 사진</div>
                        <Swiper
                            id='Aswiper1'
                            spaceBetween={10}
                            slidesPerView={4}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide className="Aslide1">All</SwiperSlide>
                            <SwiperSlide className="Aslide1">긴머리</SwiperSlide>
                            <SwiperSlide className="Aslide1">짧은머리</SwiperSlide>
                            <SwiperSlide className="Aslide1">커트</SwiperSlide>
                            <SwiperSlide className="Aslide1">염색</SwiperSlide>
                        </Swiper>
                        <div className='color'>
                            <Swiper
                                id='Aswiper1'
                                spaceBetween={15}
                                slidesPerView={5}
                                onSlideChange={() => console.log('slide change')}
                                onSwiper={(swiper) => console.log(swiper)}
                            >
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                                <SwiperSlide className="Aslide2">color</SwiperSlide>
                            </Swiper>
                        </div>
                        <div className='effect'>
                            <h4>#이 머리는 어떠세요?</h4>
                            <div className='effect_wrap'>
                                <div className='effect_img'><AiOutlinePicture className='effect_icon'/></div>
                                <div className='effect_img'><AiOutlinePicture className='effect_icon'/></div>
                                <div className='effect_img'><AiOutlinePicture className='effect_icon'/></div>
                            </div>
                        </div>
                    </>
                } />
            </Routes>
            {/* 푸터 */}
            <Footer/>
        </>
    )
};

export default Ai;